import Modal from "common/Modal/Modal";
import React from "react";
import Text from "common/Typography/Text";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";
import { useTheme } from "styled-components";
import Space from "antd/es/space";
import {
  BulkUpdateBotsModalProps,
  BulkUpdateBotStep,
} from "@shared/features/bots/types";
import useBulkUpdateBotsModal from "@shared/features/bots/useBulkUpdateBotsModal";
import { displayResultMessage } from "utils/misc";
import SellExistingCoinsOptions from "features/trades/CancelTrade/SellExistingCoinsOptions";
import InactiveAccountWarning from "features/trades/CancelTrade/InactiveAccountWarning";
import Radio from "common/Radio/Radio";

const BulkUpdateBotsModal = ({
  open,
  botsIDs,
  closeModal,
  isDeactivate,
  onFinish,
  botType,
  botIDToBotData,
}: BulkUpdateBotsModalProps) => {
  const appTheme = useTheme();
  const {
    onOkPress,
    onCloseModal,
    okText,
    cancelText,
    titleText,
    setCloseOpenTrades,
    closeOpenTrades,
    isLoading,
    step,
    confirmStepPrefixText,
    closeTradesOptionsData,
    setSellCoins,
    sellCoins,
    showExistingCoinsOptions,
    isInactiveSymbolBot,
    numInvalidAccounts,
    confirmationText,
  } = useBulkUpdateBotsModal({
    open,
    botsIDs,
    closeModal,
    isDeactivate,
    onFinish,
    displayResultMessage,
    botType,
    botIDToBotData,
  });

  const getContent = () => {
    if (step === BulkUpdateBotStep.CLOSE_TRADES) {
      return (
        <div>
          <Text>{closeTradesOptionsData.mainText}</Text>
          <Radio.Group
            onChange={(e) => setCloseOpenTrades(e.target.value)}
            value={closeOpenTrades}
            style={{ marginTop: 8 }}
          >
            <Space orientation="vertical">
              {closeTradesOptionsData.options.map((option, index) => {
                return (
                  <Radio value={option.value} key={index}>
                    <Text>{option.text}</Text>
                  </Radio>
                );
              })}
            </Space>
          </Radio.Group>
        </div>
      );
    } else if (step === BulkUpdateBotStep.CONFIRM_INACTIVE_ACCOUNT) {
      return (
        <InactiveAccountWarning
          numItems={botsIDs?.length}
          isBots={true}
          numInvalidItems={numInvalidAccounts}
        />
      );
    } else if (step === BulkUpdateBotStep.CONFIRM) {
      return (
        <LoadingSpinnerOverlay
          isLoading={isLoading}
          hideContentWhileLoading={false}
          wrap={true}
          backgroundColor={appTheme.colors.cardBgColor}
        >
          {confirmStepPrefixText && (
            <Text style={{ marginBottom: 6 }}>{confirmStepPrefixText}</Text>
          )}
          {showExistingCoinsOptions ? (
            <SellExistingCoinsOptions
              sellCoins={sellCoins}
              setSellCoins={setSellCoins}
              isSymbolInactive={isInactiveSymbolBot}
              isBot={true}
            />
          ) : (
            confirmationText.map((text, index) => (
              <Text style={{ marginTop: index ? 4 : 0 }} key={index}>
                {text}
              </Text>
            ))
          )}
        </LoadingSpinnerOverlay>
      );
    }
  };

  return (
    <Modal
      onCancel={onCloseModal}
      open={open}
      title={titleText}
      onOk={onOkPress}
      okText={okText}
      cancelText={cancelText}
      okButtonProps={{
        loading: isLoading,
      }}
      cancelButtonProps={{ disabled: isLoading }}
      destroyOnHidden={true}
    >
      {getContent()}
    </Modal>
  );
};

export default BulkUpdateBotsModal;
